import { IconProps } from 'interfaces';
import COLOR from 'constants/color';

const VideoList = ({
  fill = COLOR.GRAY['900'],
  className = 'w-4 h-4',
  styles
}: IconProps) => {
  return (
    <svg
      className={styles || className}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      preserveAspectRatio='xMidYMid meet'
    >
      <rect
        x='2'
        y='4'
        width='20'
        height='16'
        rx='2'
        stroke={fill}
        strokeWidth='2'
        fill='none'
      />
      <path
        d='M2 8h20M2 12h20M2 16h20'
        stroke={fill}
        strokeWidth='2'
        strokeLinecap='round'
      />
    </svg>
  );
};

export default VideoList;
